import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'rr-spinner',
  standalone: false,

  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent implements AfterViewInit {
  @Input() inverse: boolean = false;
  longloadingText: string = ""

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.longloadingText = "Just loading...";
    }, 1000);
    setTimeout(() => {
      this.longloadingText = "We are thinking...";
    }, 4000);
    setTimeout(() => {
      this.longloadingText = "No hurry the AI is working...";
    }, 8000);
  }
}
